export default function tagsReducer(state, action) {
  console.log('----Start State Update----', action, state);
  if (action.type === 'INITIAL_SETUP') {
    return {
      ...state,
      tags: action.tags,
    };
  } else if (action.type === 'UPDATE_TAG') {
    return {
      ...state,
      tags: state.tags.map((tag) => {
        if (tag._id === action.tag._id) {
          return {
            ...tag,
            ...action.tag,
          };
        }
        return tag;
      }),
    };
  } else if (action.type === 'ADD_TAG') {
    return {
      ...state,
      tags: state.tags.concat([action.tag]),
    };
  } else if (action.type === 'DELETE_TAG') {
    return {
      ...state,
      tags: state.tags.filter(tag => (tag._id !== action.tagId)),
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/tags.js